export const toObject = (properties, value) =>
  properties.reduce((obj, item) => {
    obj[item] = value;
    return obj;
  }, {});
